// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"167":"1344cfe0","602":"00220d3d","857":"9fcd5294","880":"944498db"}[chunkId] + ".chunk.css";
};